module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_costumes-253adc3697acde8b19dc8df16e8abba6.jpg";